import { defaultDocumentOptions } from "../constants";

import {
  pixelRegex,
  pixelToTWIP,
  cmRegex,
  cmToTWIP,
  inchRegex,
  inchToTWIP,
  pointRegex,
  pointToHIP,
} from "./unit-conversion";

const fixupFontSize = (fontSize: any) => {
  let normalizedFontSize;

  if (pointRegex.test(fontSize)) {
    const matchedParts = fontSize.match(pointRegex);

    normalizedFontSize = pointToHIP(matchedParts[1]);
  } else if (fontSize) {
    // assuming it is already in HIP
    normalizedFontSize = fontSize;
  } else {
    normalizedFontSize = null;
  }

  return normalizedFontSize;
};

const normalizeUnits = (
  dimensioningObject: any,
  defaultDimensionsProperty: any,
) => {
  let normalizedUnitResult: any = {};

  if (typeof dimensioningObject === "object" && dimensioningObject !== null) {
    Object.keys(dimensioningObject).forEach((key) => {
      if (pixelRegex.test(dimensioningObject[key])) {
        const matchedParts = dimensioningObject[key].match(pixelRegex);

        normalizedUnitResult[key] = pixelToTWIP(matchedParts[1]);
      } else if (cmRegex.test(dimensioningObject[key])) {
        const matchedParts = dimensioningObject[key].match(cmRegex);

        normalizedUnitResult[key] = cmToTWIP(matchedParts[1]);
      } else if (inchRegex.test(dimensioningObject[key])) {
        const matchedParts = dimensioningObject[key].match(inchRegex);

        normalizedUnitResult[key] = inchToTWIP(matchedParts[1]);
      } else if (dimensioningObject[key]) {
        normalizedUnitResult[key] = dimensioningObject[key];
      } else {
        // incase value is something like 0
        normalizedUnitResult[key] = defaultDimensionsProperty[key];
      }
    });
  } else {
    normalizedUnitResult = null;
  }

  return normalizedUnitResult;
};

/**
 * Creates document options by normalizing the provided options and merging them with default options.
 *
 * @param {Object} documentOptions - The user-provided document options.
 * @returns {Object} - The merged and normalized document options.
 */

const createDocumentOptionsAndMergeWithDefaults = (documentOptions: any) => {
  // Start with a shallow copy of the user-provided options to avoid mutating the original object
  const normalizedDocumentOptions = { ...documentOptions };

  // Iterate over each key in the user-provided options
  Object.keys(documentOptions).forEach((key) => {
    switch (key) {
      case "pageSize":
      case "margins":
        normalizedDocumentOptions[key] = normalizeUnits(
          (documentOptions as any)[key],
          (defaultDocumentOptions as any)[key],
        );
        break;
      case "fontSize":
      case "complexScriptFontSize":
        normalizedDocumentOptions[key] = fixupFontSize(
          (documentOptions as any)[key],
        );
        break;
      // If there are other keys that require normalization, handle them here
      default:
        // No normalization needed; retain the original value
        break;
    }
  });

  // Merge the normalized options with the default options.
  // User-provided options take precedence over default options.
  return { ...defaultDocumentOptions, ...normalizedDocumentOptions };
};

export default createDocumentOptionsAndMergeWithDefaults;
